module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._t("default", null, {
    state: _vm.state,
    open: _vm.open,
    close: _vm.close,
    data: _vm.data,
    openWithData: _vm.openWithData
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fbfe2228","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/ModalControl.vue
// module id = Hxds
// module chunks = 1